import React from 'react'
import { Switch, Route, useHistory } from 'react-router-dom'

import './assets/scss/style.scss'

import { StyleInfo } from './pages/styleInfo'
import { ResultsPage } from './pages/results'
import { ScheduleCall } from './pages/scheduleCall'
import { CallScheduled } from './pages/callScheduled'

import { PATH_URL } from './helpers'
import { useAppBase } from './helpers/app'
import { LoaderFullScreen, LoaderFullScreenWithTestimonial } from './common'
import { CustomerExperiencePage } from './pages/customerExperience'
import { MoodBoard } from './pages/moodboard'
import { CallScheduler } from './pages/callScheduler'
import { PostMoodboard } from './pages/postMoodboard'
import { QuizQuestion } from './pages/quiz/QuizQuestionProvider'
import { useSegmentPage } from './helpers/hooks/useSegmentPage'
import { ENV } from './config/env'
import { QuizType } from './pages/shared'

const AppBase: React.FC = () => {
  const history = useHistory()
  const { isLoading, isLoadingTestimonial } = useAppBase()

  if (history.location.pathname === '/') {
    console.log('redirecting')
    const currentParams = new URLSearchParams(window.location.search)

    const redirectTo = (baseUrl: string, additionalParams: Record<string, string> = {}, delay = 0): void => {
      const url = new URL(baseUrl, window.location.origin)
      currentParams.forEach((value, key) => {
        // Don't pass serviceabilityData to next redirect
        if (!additionalParams.hasOwnProperty(key)) {
          url.searchParams.append(key, value)
        }
      })
      for (const [key, value] of Object.entries(additionalParams)) {
        url.searchParams.set(key, value)
      }

      if (delay > 0) {
        console.log(`Delaying redirect to ${baseUrl} for ${delay}ms to allow setting variables`)
        setTimeout(() => {
          location.replace(url.toString())
        }, delay)
      } else {
        location.replace(url.toString())
      }
    }

    console.log('dotenv', process.env.REACT_APP_DEFAULT_EXPERIENCE)
    console.log('ENV.', ENV.REACT_APP_DEFAULT_EXPERIENCE)

    // Check if window.USE_PINTEREST_FLOW is set to true
    if (window.USE_PINTEREST_FLOW === true) {
      redirectTo(PATH_URL.PINTEREST_AVAILABILITY, { quizType: QuizType.PINTEREST })
    } else {
      // Use the existing random factor logic as fallback
      const factor = Math.random()
      if (factor <= +ENV.PINTEREST_FLOW_WEIGHT) {
        redirectTo(PATH_URL.PINTEREST_AVAILABILITY, { quizType: QuizType.PINTEREST })
      } else if (
        (ENV.REACT_APP_DEFAULT_EXPERIENCE === 'legacy' || window.location.search.includes('quizData')) &&
        !window.location.search.includes('serviceabilityData')
      ) {
        redirectTo(PATH_URL.DETAILS)
      } else {
        // Add a 1-second delay when redirecting to color-palettes page to allow time for setting variables
        redirectTo(PATH_URL.NEW_COLOR_PALETTE_PAGE, {}, 1000)
      }
    }
  }

  useSegmentPage()
  return (
    <>
      {isLoading && <LoaderFullScreen />}
      {isLoadingTestimonial && <LoaderFullScreenWithTestimonial />}
      <Switch>
        <Route path={PATH_URL.STYLE_INFO} component={StyleInfo} />
        <Route path={PATH_URL.YOUR_POPPY_PROPOSAL} component={ResultsPage} />
        <Route path={PATH_URL.CALL_SCHEDULED} component={CallScheduled} />
        <Route path={PATH_URL.$500_CUSTOMER} component={CustomerExperiencePage} />
        <Route path={PATH_URL.SCHEDULE_YOUR_CONSULTATION} component={ScheduleCall} />
        <Route path={PATH_URL.MOODBOARD} component={MoodBoard} />
        <Route path={PATH_URL.POST_MOODBOARD} component={PostMoodboard} />
        <Route path={PATH_URL.SCHEDULE_A_CALL} component={CallScheduler} />
        <Route path={PATH_URL.SWIPING} component={QuizQuestion} />
        <Route path="*" component={QuizQuestion} />
      </Switch>
    </>
  )
}

export default AppBase
